module.exports = __webpack_public_path__ + "media/assets/avia/common/search-3db6a7d734540c6aae617bc56bbd5f2e.png";